import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Award } from "assets/images/svgs/minor/award.svg";
import { ReactComponent as AwardLink } from "assets/images/svgs/minor/award-link.svg";
import { ReactComponent as Star } from "assets/images/svgs/minor/star.svg";
import { ReactComponent as FavouriteChart } from "assets/images/svgs/minor/favorite.svg";
import { ReactComponent as User } from "assets/images/svgs/minor/members.svg";
import { ReactComponent as EditTwo } from "assets/images/svgs/minor/edit.svg";
import { ReactComponent as FavoriteChart } from "assets/images/svgs/minor/favorite.svg";
import { ReactComponent as Verify } from "assets/images/svgs/minor/badges.svg";
import { ReactComponent as SecurityUser } from "assets/images/svgs/minor/support.svg";
import { ReactComponent as Setting } from "assets/images/svgs/minor/setting.svg";
import { ReactComponent as Logout } from "assets/images/svgs/minor/logout.svg";
import CustomerSupport from "../CustomerSupport";
import useStore from "hooks/useStore";
import {
  differenceInDays,
  differenceInMonths,
  differenceInYears,
} from "date-fns";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const MinorNavbarDrawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
  const { getUserProfilePic, getUserFullName, getUser } = useStore();
  const userProfilePic = getUserProfilePic();
  const userFullName = getUserFullName();
  const user = getUser();
  const totalExperiences = user?.profiles?.child?.experiences || 0;
  const totalBadges = user?.profiles?.child?.badgesEarned || 0;

  const createdAtDate = user?.user?.createdAt || new Date();
  const now = new Date();
  const createdAt = new Date(createdAtDate);
  const years = differenceInYears(now, createdAt);
  const months = differenceInMonths(now, createdAt);
  const days = differenceInDays(now, createdAt);
  let timeSince = "";
  if (years >= 1) {
    timeSince = `${years} year${years > 1 ? "s" : ""}`;
  } else if (months >= 1) {
    timeSince = `${months} month${months > 1 ? "s" : ""}`;
  } else {
    timeSince = `${days} day${days > 1 ? "s" : ""}`;
  }

  const [showSupportDrawer, setShowSupportDrawer] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const handleNavigation = (item: any) => {
    if (item.label === "Logout") {
      localStorage.clear();
      onClose();
      navigate(item.link);
      return;
    }

    if (item.label === "Customer Support") {
      // Open the Customer Support modal
      setShowSupportDrawer(true);

      return;
    }

    onClose();
    navigate(item.link);
  };

  return (
    <Fragment>
      <div
        className={`fixed inset-0 z-50 bg-black bg-opacity-30 transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      >
        <div
          className={`fixed top-0 right-0 h-full w-4/5 sm:w-1/2 md:w-1/3 lg:w-[480px] overflow-y-auto bg-white p-4 md:p-10 shadow-lg transition-transform duration-300 ease-in-out transform ${
            isOpen ? "translate-x-0" : "translate-x-full"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
          >
            &times;
          </button>

          <div className="flex items-center space-x-4 mt-6">
            <img
              src={userProfilePic}
              alt="Profile"
              className="w-20 h-20 rounded-full object-cover"
            />
            <div>
              <h2 className="text-lg font-semibold text-primaryBlueText capitalize">
                {userFullName}
              </h2>
              {/* <span className="flex items-center justify-center text-sm w-fit px-2 h-[34px] rounded-full bg-[#F0F2F3] text-primaryBlueText">
                <Award className="mr-1 text-minorPrimary" /> {"Basic Tier"}
              </span> */}
            </div>
          </div>

          {/* Stats Section */}
          <div className="flex items-center gap-2 sm:gap-2 lg:justify-between flex-wrap lg:flex-nowrap bg-minorPrimary/10 rounded-lg lg:rounded-full px-3 py-3 mt-6">
            <span className="flex items-center text-base whitespace-nowrap text-primaryBlueText capitalize">
              <Star className="mr-1 text-minorPrimary" />
              {timeSince} Member
            </span>
            <span className="flex items-center text-base whitespace-nowrap text-primaryBlueText">
              <Award className="mr-1 text-minorPrimary" /> {totalBadges} Badges
            </span>
            <span className="flex items-center whitespace-nowrap text-base text-primaryBlueText">
              <FavouriteChart className="mr-1 text-minorPrimary" />{" "}
              {totalExperiences} Exp.
            </span>
          </div>

          <div className="mt-3 flex flex-col">
            {/* Only visible on screens smaller than md */}
            {/* <div className="md:hidden flex flex-col">
              {[
                {
                  label: " Experiences",
                  icon: <FavoriteChart className="text-minorPrimary" />,
                  link: "/minor/experiences",
                },
                {
                  label: "Digital Passport",
                  icon: <AwardLink className="text-minorPrimary" />,
                  link: "/minor/digital-passport",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleNavigation(item)}
                  className="flex py-5 items-center w-full text-left text-darkBlueText bordr-linear cursor-pointer"
                >
                  <span className="mr-3 text-lg">{item.icon}</span>
                  {item.label}
                </div>
              ))}
            </div> */}

            {/* Other links (visible on all screen sizes) */}
            <div className="flex flex-col">
              {[
                {
                  label: "Edit Profile",
                  icon: <EditTwo className="text-minorPrimary" />,
                  link: "/minor/edit-profile",
                },
                {
                  label: "My Experiences",
                  icon: <FavoriteChart className="text-minorPrimary" />,
                  link: "/minor/experiences",
                },

                {
                  label: "My Badges",
                  icon: <Verify className="text-minorPrimary" />,
                  link: "/minor/digital-passport",
                },
                // {
                //   label: "Favorite Hosts",
                //   icon: <SecurityUser />,
                //   link: "/minor/favorite-host",
                // },
                {
                  label: "General Settings",
                  icon: <Setting className="text-minorPrimary" />,
                  link: "/minor/general-setting",
                },
                // {
                //   label: "Customer Support",
                //   icon: <SecurityUser className="text-minorPrimary" />,
                //   link: "#",
                // },
                {
                  label: "Logout",
                  icon: <Logout className="text-minorPrimary" />,
                  link: "/auth/login",
                },
              ].map((item, index, array) => (
                <div
                  key={index}
                  onClick={() => handleNavigation(item)}
                  className={`flex  items-center w-full text-left text-darkBlueText cursor-pointer ${
                    index === array.length - 1 ? " pt-5" : "bordr-linear py-5"
                  }`}
                >
                  <span className="mr-3 text-lg">{item.icon}</span>
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Customer Support Modal */}

      {showSupportDrawer && (
        <CustomerSupport
          isOpen={showSupportDrawer}
          onClose={() => setShowSupportDrawer(false)}
        />
      )}
    </Fragment>
  );
};

export default MinorNavbarDrawer;
